import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

const MOODS = [
  { score: 5, label: "hopeful", color: "#8E9E82" },
  { score: 4, label: "calm", color: "#A4B39A" },
  { score: 3, label: "okay", color: "#D1B280" },
  { score: 2, label: "stressed", color: "#C48A6A" },
  { score: 1, label: "anxious", color: "#A96F6E" },
];

export const MoodTracker = () => {
  const [recent, setRecent] = useState([]);
  const [saving, setSaving] = useState(false);

  const load = () => {
    api.get("/mood").then((r) => setRecent(r.data.slice(0, 7))).catch(() => {});
  };

  useEffect(() => {
    load();
  }, []);

  const logMood = async (m) => {
    setSaving(true);
    try {
      await api.post("/mood", { score: m.score, label: m.label });
      toast.success(`Noted — ${m.label}`);
      load();
    } catch {
      toast.error("Couldn't save");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className="rounded-3xl p-6 md:p-8 border bg-white"
      style={{ borderColor: "var(--border)" }}
      data-testid="mood-tracker"
    >
      <p className="text-xs uppercase tracking-[0.15em] mb-2" style={{ color: "var(--muted)" }}>
        A gentle check-in
      </p>
      <h3 className="font-serif text-2xl md:text-3xl mb-5" style={{ color: "var(--ink)" }}>
        How are you, right now?
      </h3>
      <div className="flex flex-wrap gap-2">
        {MOODS.map((m) => (
          <button
            key={m.label}
            onClick={() => logMood(m)}
            disabled={saving}
            className="px-4 py-2 rounded-full text-sm transition-all hover:-translate-y-0.5 border"
            style={{
              backgroundColor: "var(--surface-2)",
              borderColor: "var(--border)",
              color: "var(--ink)",
            }}
            data-testid={`mood-${m.label}-btn`}
          >
            <span
              className="inline-block w-2 h-2 rounded-full mr-2 align-middle"
              style={{ backgroundColor: m.color }}
            />
            {m.label}
          </button>
        ))}
      </div>
      {recent.length > 0 && (
        <div className="mt-6 flex items-end gap-1.5 h-12" data-testid="mood-recent">
          {[...recent].reverse().map((e, i) => {
            const mood = MOODS.find((m) => m.label === e.label) || MOODS[2];
            return (
              <div
                key={e.id || i}
                className="flex-1 rounded-t-md"
                style={{
                  backgroundColor: mood.color,
                  height: `${(e.score / 5) * 100}%`,
                  minHeight: "8px",
                  opacity: 0.8,
                }}
                title={`${e.label} · ${new Date(e.created_at).toLocaleDateString()}`}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};
